import { raceOptions } from "@/lib/strings/profile-data";

export const SEX_OPTIONS = ["Male", "Female"] as const;

export const GENDER_IDENTITY_OPTIONS = [
  "Woman",
  "Man",
  "Non-binary",
  "Transgender",
  "Prefer to self-describe",
  "Prefer not to say",
] as const;

export const PRONOUN_OPTIONS = [
  "she/her",
  "he/him",
  "they/them",
  "she/they",
  "he/they",
  "Prefer not to say",
] as const;

export const RACE_OPTIONS = raceOptions.map((option) => option.value);

export const normalizeRace = (value?: string | null): string | undefined => {
  if (!value) return undefined;
  return RACE_OPTIONS.includes(value) ? value : "Other";
};
